export default {
    challenge: 'Challenge',
    opportunity: 'Opportunity',
    ai: {
        textPlaceholder: 'please select/enter',
        selectHeader: 'please select or use input field',
        textPostfix: 'industry?',
        textPrefix: 'Which are potential Challenges and Opportunities for the',
        createButton: 'Add',
        disclaimer: 'The results are generated by artificial intelligence and are primarily used for inspiration. We recommend an individual assessment of the relevance and plausibility of this content.'
    },
    listItem: {
        metadataOn: 'Created on {createdOn}',
        metadataOnFrom: 'Created on {createdOn} by {author}',
        metadataFrom: 'Created by {author}',
        deleteConfirmationDialog: {
            title: 'Delete Challenges and Opportunities ',
            content: 'Do you really want to delete this Challenges and Opportunities entry?',
            cancelButton: 'Cancel',
            confirmButton: 'Yes, delete entry'
        },
        cAndOFormTextContent: {
            title: {
                placeholder: 'Title',
                validationErrors: {
                    required: 'Please enter a title'
                }
            },
            challenge: {
                placeholder: 'Challenge',
                validationErrors: {
                    required: 'Please enter a challenge'
                }
            },
            opportunity: {
                placeholder: 'Opportunity',
                validationErrors: {
                    required: 'Please enter a opportunity'
                }
            }
        },
        deleteButton: 'Delete C&O',
        cancelButton: 'Cancel',
        submitButton: 'Create',
        saveButton: 'Save',
        editButtonTitle: 'Edit'
    }
}
